<style>
@import "@vueform/multiselect/themes/default.css";
.calculator-component {
    display: flex;
    flex-direction: row;
    gap: 20px;
}
.calculator-component-wrapper {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 60px;
    flex: 0 0 50%;
}

.calculator-component-wrapper-header {
    display: flex;
    justify-content: space-between;
    gap: 20px;
}

.calculator-component .calculator-component-illustration img {
    width: 100%;
}

.calculator-component-wrapper-header h4 {
    color: #6A6161;
    font-size: 26px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-bottom: 0;
}

.calculator-component-wrapper-header h4.active {
    color: var(--color-pink);
}

.card-body-item-content {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.card-body-item-wrapper {
    flex: 0 1 calc(33.33% - 7px);
}

.card-body-item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
    box-shadow: 1px 1px 5px gray;
    border-radius: 10px;
    transition: all 300ms ease-in;
    height: 100%;
}

#calculator-form {
    display: flex;
    flex-direction: column;
    gap: 46px;
}

#calculator-form .form-floating .form-control, #calculator-form .form-select-wrapper .form-select {
    border-radius: 30px;
    border: 1px solid #D9EAFD;
}

#calculator-form .form-floating label:not(.form-check-label) {
    padding: 12px 30px;
}

#calculator-form .form-select-wrapper label {
    margin-left: 10px;
    color: var(--color-pink);
}

.calculator-results {
    border-top: 1px solid var(--color-pink);
    padding-top: 20px;
    margin-top: 20px;
}

.card-body-item.active {
    box-shadow: 2px 2px 20px var(--color-pink);
    outline: 1px solid var(--color-pink-light);
}

.card-body-item:hover {
    box-shadow: 1px 1px 20px gray;
}

.card-body-item .card-body-item-description {
    font-size: 14px;
    color: lightgrey;
}

.card-body-item .card-body-item-delivery-method {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 5px;
}

.card-body-item .card-body-item-details {
    list-style: none;
}

.card-body-item .card-body-item-details li {
    font-size: 16px;
}

.card-body-item .card-body-item-details li:not(:last-child) {
    margin-bottom: 5px;
}

.calculator-submit-btn {
    padding: 17px 27px 20px 23px;
    gap: 12px;
    align-items: center;
    justify-content: space-between;
}

.calculator-submit-btn span {
    color: var(--color-pink-light);
    font-size: 30px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.form-select-wrapper label {
    font-size: 12px;
}

.calculator-item-img {
    max-height: 20px;
}

.service-details-wrapper p {
    margin-bottom: 0;
}

.service-details-wrapper .service-header {
    border-bottom: 1px solid var(--color-pink);
    padding-bottom: 15px;
}

.service-details-wrapper .service-header .service-header-title {
    font-size: 24px;
}

.service-details-wrapper .service-description {
    font-size: 20px;
}

.service-body-details {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}

.service-body-details .service-body-details-item {
    flex: 0 1 calc(50% - 20px);
}

.service-footer {
    border-top: 1px solid var(--color-pink);
    padding-top: 20px;
}

.multiselect, .multiselect-search {
    border-radius: 30px;
    font-size: 13px;
}

.multiselect .multiselect-option, .multiselect-placeholder {
    font-size: 13px;
}


@media (max-width: 991px) {
    .calculator-component {
        flex-direction: column;
    }

    .calculator-component-wrapper {
        flex: 1;
        gap: 20px;
    }

    .card-body-item-wrapper {
        flex: 0 1 calc(50% - 5px);
    }

    .calculator-submit-btn span {
        font-size: 18px;
    }

    .calculator-component-wrapper-header h4 {
        font-size: 16px;
        font-weight: 600;
    }

    .service-details-wrapper .service-header .service-header-title {
        font-size: 16px;
    }

    .calculator-component-illustration {
        border-top: 1px solid var(--color-pink);
        padding-top: 15px;
    }

    #calculator-form {
        gap: 10px;
    }

    .calculator-submit-btn {
        width: 100%;
        justify-content: center;
        padding: 10px 15px;

    }
}
</style>

<template>
    <div class="calculator-component">
        <div class="calculator-component-wrapper">
            <div class="calculator-component-wrapper-header">
                <h4 class="active">{{ $t('Online shipping cost calculator') }}</h4>
            </div>
            <div class="calculator-component-wrapper-inputs">
                <div class="calculator-form-section">
                    <form id="calculator-form" @keydown.enter.prevent="getResults">
                        <div class="row">
                            <div class="form-floating mb-2 col-lg-6">
                                <input id="weight" name="weight" type="text" v-model="data.weight" class="form-control" :placeholder="$t('Weight lb/kg')">
                                <label for="weight">{{ $t('Weight lb/kg') }}</label>
                                <div class="invalid-feedback d-block" v-if="validationErrors?.weight">{{ validationErrors?.weight[0] }}</div>

                            </div>
                            <div class="form-select-wrapper mb-2 col-lg-6">
                                <select class="form-select" name="unit" v-model="data.unit" :aria-label="$t('Pound')">
                                    <option selected value="0">{{ $t('Pound') }}</option>
                                    <option value="1">{{ $t('Kg') }}</option>
                                </select>
                                <div class="invalid-feedback d-block" v-if="validationErrors?.unit">{{ validationErrors?.unit[0] }}</div>
                            </div>
                            <div class="form-select-wrapper mb-2 col-lg-6">
                                <Multiselect
                                    v-model="data.country"
                                    :options="countries"
                                    value-prop="id"
                                    :searchable="true"
                                    :placeholder="$t('Select the country of delivery')"
                                    @keydown.stop
                                />
                                <label for="country">{{ $t('Select the country of delivery') }}</label>
                                <div class="invalid-feedback d-block" v-if="validationErrors?.country">{{ validationErrors?.country[0] }}</div>
                            </div>
                            <div class="form-floating mb-2 col-lg-6">
                                <input id="zip" type="text" name="zip" class="form-control" v-model="data.zip" :placeholder="$t('Postal Code')">
                                <label for="zip">{{ $t('Postal Code') }}</label>
                                <div class="invalid-feedback d-block" v-if="validationErrors?.zip">{{ validationErrors?.zip[0] }}</div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-center">
                            <button type="button" @click="getResults" :class="loading ? 'disabled' : ''" class="calculator-submit-btn btn btn-primary rounded-pill">
                                <span>{{ $t('Calculate') }}</span>
                                <img v-if="loading" src="@images/themes/sandbox/ajax-loader.gif" width="24" height="24" alt="Ajax Loading">
                            </button>
                        </div>
                    </form>
                    <div class="calculator-results" v-if="results.length">
                        <div class="card-body-item-content">
                            <div class="card-body-item-wrapper text-center" v-for="rateItem in results" @click="getServiceInfo(rateItem)">
                                <div class="p-2 m-0 card-body-item" :class="{ active: selectedService?.id === rateItem?.id }">
                                    <div class="row justify-content-between">
                                        <div class="col-md-12">
                                            <h6 class="m-0">{{ rateItem?.name }}</h6>
                                            <small class="text-aqua"><b>{{ rateItem.details.days_from + ' - ' + rateItem.details.days_to + ' ' + (rateItem.details.is_week ? $t("Weeks") : $t("Days")) }}</b></small>
                                        </div>
                                        <div class="col-md-12 mt-2 mb-2">
                                            <img v-if="rateItem?.name?.toLowerCase()?.includes('usps')" src="@images/themes/sandbox/services/USPSLogo.webp" class="calculator-item-img" alt="USPS">
                                            <img v-else-if="rateItem?.name?.toLowerCase()?.includes('aramex')" src="@images/themes/sandbox/services/AramexLogo.webp" class="calculator-item-img" alt="Aramex">
                                            <img v-else-if="rateItem?.name?.toLowerCase()?.includes('globalpost')" src="@images/themes/sandbox/services/GlobalPostLogo.webp" class="calculator-item-img" alt="GlobalPost">
                                            <img v-else-if="rateItem?.name?.toLowerCase()?.includes('fedex')" src="@images/themes/sandbox/services/FedExLogo.webp" class="calculator-item-img" alt="FedEx">
                                            <img v-else-if="rateItem?.name?.toLowerCase()?.includes('ups')" src="@images/themes/sandbox/services/UPSLogo.webp" class="calculator-item-img" alt="UPS">
                                            <img v-else-if="rateItem?.name?.toLowerCase()?.includes('dhl')" src="@images/themes/sandbox/services/DHLLogo.webp" class="calculator-item-img" alt="DHL">
                                            <img v-else-if="rateItem?.name?.toLowerCase()?.includes('boxberry')" src="@images/themes/sandbox/services/logo-boxberry.webp" class="calculator-item-img" alt="DHL">
                                            <img v-else-if="rateItem?.name?.toLowerCase()?.includes('cargo')" src="@images/themes/sandbox/services/CargoLogo.webp" class="calculator-item-img" alt="Cargo">
                                            <img v-else src="@images/themes/sandbox/services/Russian_postLogo.webp" class="calculator-item-img" alt="WCargo">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <p class="display-6 text-primary mb-0">$ {{ rateItem.rate.toFixed(2) }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="calculator-component-illustration w-100">
            <div class="service-details-wrapper" v-if="selectedService">
                <div class="service-header d-flex justify-content-between align-items-center gap-2">
                    <h5 class="service-header-title m-0">{{ selectedService?.name }}</h5>
                    <p class="text-aqua m-0"><b>{{ selectedService?.details.days_from + ' - ' + selectedService?.details.days_to + ' ' + (selectedService?.details.is_week ? $t("Weeks") : $t("Days")) }}</b></p>
                    <h5 class="display-5 m-0 text-primary">${{ selectedService?.rate }}</h5>
                </div>
                <div class="service-body">
                    <p class="service-description pt-4" v-html="selectedService?.details.description"></p>
                    <div class="service-body-details mt-5 mb-5">
                        <div class="service-body-details-item" v-if="selectedService?.details?.dimensional_weight_description">
                            <label class="text-dark"><b>{{ $t('Dimensional Weight') }}</b></label>
                            <p v-html="selectedService?.details?.dimensional_weight_description"></p>
                        </div>
                        <div class="service-body-details-item" v-if="selectedService?.details?.size_description">
                            <label class="text-dark"><b>{{ $t('Size') }}</b></label>
                            <p v-html="selectedService?.details?.size_description"></p>
                        </div>
                        <div class="service-body-details-item" v-if="selectedService?.details?.sending_frequency_description">
                            <label class="text-dark"><b>{{ $t('Sending frequency') }}</b></label>
                            <p v-html="selectedService?.details?.sending_frequency_description"></p>
                        </div>
                        <div class="service-body-details-item" v-if="selectedService?.details?.insurance_description">
                            <label class="text-dark"><b>{{ $t('Insurance') }}</b></label>
                            <p v-html="selectedService?.details?.insurance_description"></p>
                        </div>
                        <div class="service-body-details-item" v-if="selectedService?.details?.tracking_parcel_description">
                            <label class="text-dark"><b>{{ $t('Tracking Parcel') }}</b></label>
                            <p v-html="selectedService?.details?.tracking_parcel_description"></p>
                        </div>
                        <div class="service-body-details-item" v-if="selectedService?.details?.delivery_partners_description">
                            <label class="text-dark"><b>{{ $t('Delivery Partners') }}</b></label>
                            <p v-html="selectedService?.details?.delivery_partners_description"></p>
                        </div>
                        <div class="service-body-details-item" v-if="selectedService?.details?.customs_limit_description">
                            <label class="text-dark"><b>{{ $t('Customs Limit') }}</b></label>
                            <p v-html="selectedService?.details?.customs_limit_description"></p>
                        </div>
                        <div class="service-body-details-item" v-if="selectedService?.details?.max_weight_description">
                            <label class="text-dark"><b>{{ $t('Max Weight') }}</b></label>
                            <p v-html="selectedService?.details?.max_weight_description"></p>
                        </div>
                    </div>
                </div>
                <div class="service-footer">
                    <p v-html="selectedService?.details?.additional_description"></p>
                </div>
            </div>
            <img v-else src="@images/home/calculator-illustration.webp" alt="Calculator Illustration">
        </div>
    </div>
</template>

<script>
import toastr from "toastr";
import Multiselect from '@vueform/multiselect'
export default {
    name: "calculator-component",
    components: {
        Multiselect
    },
    data() {
        return {
            selectedService: null,
            loading: false,
            data: {
                weight: '',
                unit: '0',
                country: '',
                zip: '',
                insurance: ''
            }
        }
    },
    async mounted() {
        this.$store.dispatch("countries/getCountries").then(() => {
            if (document.documentElement.lang === "ru") {
                this.moveCountryToFirstPlace(182);
            }
        });
    },
    computed: {
        results () {
            return this.$store.getters.getCalculateResults
        },
        hasError() {
            return (field) => {
                return Array.isArray(this.validationErrors) && this.validationErrors.some(error => error.includes(field));
            };
        },
        validationErrors() {
            return this.$store.getters.getValidationErrors;
        },
        countries() {
            return this.$store.getters['countries/getCountries'].map(item => {
                return {
                    id: item.id,
                    label: item.name,
                    name: item.name,
                    value: item.name
                }
            });
        }
    },
    methods: {
        moveCountryToFirstPlace(countryId) {
            const index = this.countries.findIndex(country => country.id === countryId);
            if (index !== -1) {
                const country = this.countries.splice(index, 1)[0];
                this.$store.commit('countries/setterCountries', [country, ...this.countries]);
            }
        },
        async getResults() {
            this.loading = true;
            this.selectedService = null;
            this.$store.commit('clearCalculateResults');
            this.$store.commit('clearValidationErrors');

            await this.$store
                .dispatch("getCalculateResults", this.data)
                .then(() => {
                    if (this.results.length === 0) {
                        toastr.error(
                            this.$t("Unfortunately, the weight you entered exceeds the maximum allowed for all available shipping methods to this country.",)
                        );
                    }

                    this.loading = false;
                    this.selectedService = this.results?.[0] ?? null;
                })
                .catch((error) => {
                    this.loading = false;
                    this.selectedService = this.results?.[0] ?? null;
                    toastr.error(this.$t("An error occurred during the updating"));
                });
        },
        getServiceInfo(item) {
            this.selectedService = item;
        }
    }
}

</script>
